import api from 'api';



let typesRaw = {
	SET_STATE: 'SET_STATE',
	RESET_ALL: 'RESET_ALL',
};

export const types = Object.keys(typesRaw).reduce((all, key) => ({
	...all,
	[ key ]: `PRODUCT_CONFIGURATOR/CUSTOMER_CATEGORIES/${typesRaw[ key ]}`,
}), {});



const initialState = {
	loading: false,
	loaded: false,
	saving: false,
	rows: [],

	modal_open: false,
	modal_mode: 'new',
	modal_customer_category_id: null,
	modal_label: '',
	modal_notes: '',
	modal_active: true,
	modal_parent_id: null,
};




export const reducers = (state = initialState, action) => {
	switch (action.type) {
		case types.SET_STATE:
			return {
				...state,
				...action.data,
			};

		case types.RESET_ALL:
			return { ...initialState };

		default:
			return state;
	}
};




export const actions = {
	setState: (data) => ({ type: types.SET_STATE, data }),



	reset_all: () => ({ type: types.RESET_ALL }),



	open_new_modal: () => ({
		type: types.SET_STATE, data: {
			modal_open: true,
			modal_mode: 'new',
			modal_customer_category_id: null,
			modal_label: '',
			modal_notes: '',
			modal_active: true,
			modal_parent_id: null,
		},
	}),



	open_edit_modal: (row) => ({
		type: types.SET_STATE, data: {
			modal_open: true,
			modal_mode: 'edit',
			modal_customer_category_id: row.customer_category_id,
			modal_label: row.customer_category_label,
			modal_notes: row.notes,
			modal_active: row.active,
			modal_parent_id: row.parent_id,
		},
	}),



	close_modal: () => ({ type: types.SET_STATE, data: { modal_open: false } }),



	load: () => async (dispatch) => {
		dispatch(actions.setState({ loading: true }));

		try {
			let response = await api.get('/configurator/customer-categories');

			dispatch(actions.setState({
				rows: response.customer_categories,
				loading: false,
				loaded: true,
			}));
		} catch(err) {
			console.error(err);
			dispatch(actions.setState({ loading: false }));
		}
	},



	save_modal: () => async (dispatch, getState) => {
		const state   = getState().configurator_customer_categories,
			  payload = {
				  customer_category: {
					  customer_category_label: state.modal_label,
					  notes: state.modal_notes,
					  active: state.modal_active,
					  parent_id: state.modal_parent_id,
				  },
			  };

		dispatch(actions.setState({ saving: true }));

		try {
			if(state.modal_mode === 'edit') {
				await api.put(`/configurator/customer-categories/${state.modal_customer_category_id}`, payload);
			} else {
				await api.post('/configurator/customer-categories', payload);
			}

			dispatch(actions.setState({ saving: false, modal_open: false }));
			dispatch(actions.load());
		} catch(err) {
			// the api layer already surfaced the error message
			console.error(err);
			dispatch(actions.setState({ saving: false }));
		}
	},



	toggle_active: (row) => async (dispatch, getState) => {
		const rows = getState().configurator_customer_categories.rows,
			  next = !row.active;

		// optimistic; reload puts it back if the save fails
		dispatch(actions.setState({
			rows: rows.map(r => r.customer_category_id === row.customer_category_id
				? { ...r, active: next }
				: r),
		}));

		try {
			await api.put(`/configurator/customer-categories/${row.customer_category_id}`, {
				customer_category: {
					customer_category_label: row.customer_category_label,
					notes: row.notes,
					active: next,
				},
			});
		} catch(err) {
			console.error(err);
			dispatch(actions.load());
		}
	},



	save_tree: (rows) => async (dispatch) => {
		// optimistic; reload puts it back if the save fails
		dispatch(actions.setState({ rows }));

		try {
			let response = await api.put('/configurator/customer-categories/tree', {
				tree: rows.map(r => ({
					customer_category_id: r.customer_category_id,
					parent_id: r.parent_id,
					sort_order: r.sort_order,
				})),
			});

			dispatch(actions.setState({ rows: response.customer_categories }));
		} catch(err) {
			console.error(err);
			dispatch(actions.load());
		}
	},
};
